import { render, staticRenderFns } from "./InsurancePlanner.vue?vue&type=template&id=58eff532&scoped=true&"
import script from "./InsurancePlanner.vue?vue&type=script&lang=js&"
export * from "./InsurancePlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eff532",
  null
  
)

export default component.exports